import { hash } from "../Utils.js";
import Favorite from "./Favorite";
import FavoritesMeta from "./FavoritesMeta";
import firebase from "firebase/app";
import "firebase/auth";

const db = firebase.firestore();
const collection = db.collection("favorites");

// Manages the entire favoriting actions and caching
class FavoritesStore {
  constructor(userId, documentId) {
    this.userId = userId;
    this.documentId = documentId;
    this.initialized = false;

    // hash by favorite.id
    this.favorites = {};
    this.favoritesByCards = {};
  }

  async initialize() {
    this.meta = await FavoritesMeta.get(this.userId, this.documentId);

    // gets all favorites
    let promises = this.meta.order.map((id) => {
      return new Promise((resolve, reject) => {
        //TODO: check cache hit

        collection
          .doc(id)
          .get()
          .then((snap) => {
            if (snap.exists) {
              resolve(new Favorite(id, snap.data()));
            } else {
              resolve(false);
            }
          });
      });
    });

    let values = await Promise.all(promises);
    values.forEach((favorite) => {
      if (favorite) {
        this.favorites[favorite.id] = favorite;
      }
    });

    this.initialized = true;

    this.calculateFavoritesByCards();

    return true;
  }

  // returns a cache of all known cards and their favorites hashed by content
  getFavoritesByCards() {
    return this.favoritesByCards;
  }

  // recalculates the cache of favorites by card
  calculateFavoritesByCards() {
    this.favoritesByCards = {};

    Object.keys(this.favorites).forEach((key) => {
      let fav = this.favorites[key];
      let cardId = fav.cardId;
      let content = fav.content;

      if (!this.favoritesByCards[cardId]) {
        this.favoritesByCards[cardId] = {};
      }

      this.favoritesByCards[cardId][hash(content)] = true;
    });

    return this.favoritesByCards;
  }

  getFavoriteWithContent(cardId, content) {
    let id = Object.keys(this.favorites).find((id) => {
      return this.favorites[id].cardId == cardId && this.favorites[id].content == content;
    });

    if (id) {
      return this.favorites[id];
    } else {
      return false;
    }
  }

  // Reorders the favorite at index 'from' to 'to'
  reorder(from, to) {
    // reorder on the client first
    this.meta.reorder(from, to);

    return true;
  }

  async createFromCard(card, content) {
    if (!this.initialized) {
      return false;
    }

    // first check in cache if we've already created
    let found = Object.keys(this.favorites).some((id) => {
      let favorite = this.getFavoriteWithContent(card.id, content);

      if (favorite) {
        return favorite.content == content;
      } else {
        return false;
      }
    });

    if (found) {
      console.log("Already favorited (cache hit)");
      return false;
    }

    let favorite = await this.meta.createFromCard(card, content);

    if (!favorite) {
      // Already favorited checked on server
      return false;
    } else {
      this.favorites[favorite.id] = favorite;
      this.calculateFavoritesByCards();
    }

    return true;
  }

  async deleteFromCard(card, content) {
    if (!this.initialized) {
      return false;
    }

    let id = await this.meta.deleteFromCard(card, content);

    if (id) {
      delete this.favorites[id];
      this.calculateFavoritesByCards();
    }

    return true;
  }

  async delete(id) {
    if (!this.initialized) {
      return false;
    }

    let favorite = this.favorites[id];

    if (!favorite) {
      // doesn't exist on client, so do nothing
      return false;
    }

    if (await this.meta.delete(favorite)) {
      delete this.favorites[id];
      this.calculateFavoritesByCards();
      return true;
    } else {
      return false;
    }
  }

  async setPosition(id, index) {
    if (!this.initialized) {
      return false;
    }
  }

  getFavorite(id) {
    if (!this.initialized) {
      return false;
    }

    return this.favorites[id];
  }

  // returns array of favorites in user sorted order
  getSortedFavorites() {
    if (!this.initialized) {
      return [];
    }

    // TODO: paginate
    return this.meta.order.map((id) => {
      return this.getFavorite(id);
    });
  }
}

export default FavoritesStore;
